import { DocumentType } from '@verifime/utils';
import {
  ENTITY_DOCUMENT_REQUIREMENTS,
  ENTITY_TO_DOCUMENT_TYPE,
  TOrganisationEntityType,
} from '../constants';

export type TDocumentRequirementsResult = {
  documents: string[];
  documentType: DocumentType;
};

/**
 * Hook to get document requirements for an organization entity type.
 *
 * **Current Implementation:**
 * Returns hardcoded document requirements from constants.
 *
 * **Future Implementation:**
 * Will be replaced with API call to fetch requirements dynamically.
 * Implementation details (endpoints, state management) TBD when API is ready.
 *
 * @param entityType - The organization entity type
 * @returns Document requirements and document type
 */
export function useDocumentRequirements(
  entityType: TOrganisationEntityType,
): TDocumentRequirementsResult {
  // TODO: Replace with API call when endpoint is available

  return {
    documents: ENTITY_DOCUMENT_REQUIREMENTS[entityType],
    documentType: ENTITY_TO_DOCUMENT_TYPE[entityType],
  };
}
